const SET_PROJECT_TITLE = 'projectTitle/SET_PROJECT_TITLE';

// we are initializing to a blank string instead of an actual title,
// because it would be hard to localize here
const initialState = {
    title: '项目1',
    isCorrect: 0
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SET_PROJECT_TITLE:
            const correct = checkTitle(action.title)
            return Object.assign({}, action, {
                title: action.title,
                isCorrect: correct
            });
        default:
            return state;
    }
};
const checkTitle = function (title) {
    switch (true) {
        case /^\d/ig.test(title):
            // 开头不能为数字
            return 1;
        case /\s/ig.test(title):
            // 文件不能含空格
            return 2;
        case /[~·`!@#$%\^\&\*\(\)+\-={}\[\]:";'<>,.\?\/\|\\！￥（）——【】：“；‘、《》，。？]/ig.test(title):
            // 文件不能含数字和空格
            return 3;
        default:
            return 0
    }
}
const setProjectTitle = title => ({
    type: SET_PROJECT_TITLE,
    title: title
});

export {
    reducer as
    default,
    initialState as projectTitleInitialState,
    setProjectTitle
};
